import { isMobile } from "@modules/util/device.ts"

const starsLikesLoginModalPc = `<div class="modal modal-stars-likes-login" id="modal-stars-likes-login" role="dialog" aria-labelledby="modal-label">
    <div class="modal-dialog modal-md modal-content">
        <div class="modal-header">
            <div class="col-xs-2 icon-modal-close pull-right" data-dismiss="modal" title="Schließen">
        <span class="icon dark block icon-24">
          <svg class="icon" data-action="close">
            <use xlink:href="/ladies/images/icon-defs.svg#icon-cross-thin"></use>
          </svg>
        </span>
            </div>

            <h3 class="modal-title">
                <img class="icon icon-20 like-icon" src="/ladies/images/static-cdn/ladies-stars/img/stars-like-filled.svg" alt="♥">
                Gefällt mir
            </h3>
        </div>

        <div class="modal-body">
            <p>Diese Funktion steht nur Fans zur Verfügung.</p>
            <br />
            <p class="text-bold">Melde dich mit deinem Ladies.de-Konto an um Fan zu werden.</p>
        </div>

        <div class="modal-footer">
            <a rel="nofollow" href="/login?ref={{referrer}}" id="action-login-button" class="login-ref-url btn btn-ladies-primary col-xs-12">
                <span class="icon light inline icon-sub icon-20">
          <svg class="icon" data-action="close">
            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/ladies/images/icon-defs.svg#icon-ladies-l"></use>
          </svg>
                </span> <span class="label">Anmelden mit Ladies.de</span>
            </a>

            <p class="text-center">Du hast noch kein Konto? <a href="{{loginUrl}}/register" class="ui-link-inherit">Jetzt erstellen</a></p>
        </div>
    </div>
</div>
`

const starsLikesLoginModalMobile = `<div class="modal modal-stars-likes-login" id="modal-stars-likes-login" role="dialog" aria-labelledby="modal-label">
    <div class="modal-dialog modal-md modal-content">
        <div class="modal-header">
            <div class="col-xs-2 icon-modal-close pull-right" data-dismiss="modal" title="Schließen">
        <span class="icon light block icon-20">
          <svg class="icon" data-action="close">
            <use xlink:href="/ladies/images/icon-defs.svg#icon-cross-thin"></use>
          </svg>
        </span>
            </div>

            <h3 class="modal-title">
                <img class="icon icon-20 like-icon" src="/ladies/images/static-cdn/ladies-stars/img/stars-like-white.svg" alt="♥">
                Gefällt mir
            </h3>
        </div>

        <div class="modal-body fnt-6">
            <p>Diese Funktion steht nur Fans zur Verfügung.</p>
            <br />
            <p class="text-bold">Melde dich mit deinem Ladies.de-Konto an um Fan zu werden.</p>
            <br /><br />
            <a rel="nofollow" href="/login?ref={{referrer}}" id="action-login-button" class="login-ref-url btn btn-ladies-primary" style="width: 100%;">
                <span class="icon light inline icon-sub icon-20">
          <svg class="icon" data-action="close">
            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/ladies/images/icon-defs.svg#icon-ladies-l"></use>
          </svg>
                </span> <span class="label">Anmelden mit Ladies.de</span>
            </a>

            <p class="text-center p-10-t">Du hast noch kein Konto? <a href="{{loginUrl}}/register" class="ui-link-inherit">Jetzt erstellen</a></p>
        </div>
    </div>
</div>
`

export const starsLikesLoginModal = isMobile() ? starsLikesLoginModalMobile : starsLikesLoginModalPc
